<template lang="pug">
.order.order-report
  .p-title 订单数据
  .p-main(v-show="chooseMode")
    ChooseOrderMake(v-model="chooseMode" @get-result="changeOrder" :chooses="orderInfo" :isMorePageChoose="true")
  .p-main(v-show="!chooseMode")
    div(v-show="isFlowDetail" style="background: #fff;padding: 20px 20px 0;")
      CrowdData(:data="crowdData" v-model="isFlowDetail" @back="isFlowDetail = false" :codes="codes" :orders="orders" :time="putDateStr")
    div(v-show="showChoosedOrder" style="background: #fff;padding: 20px 20px 0;")
      ChoosedOrder(:data="orderInfo" @back="showChoosedOrder = false")
    div(v-show="!isFlowDetail && !showChoosedOrder" style="padding-top: 217px;")
      .order_message
        .top
          h6(v-if="orderInfo.length")
            span(v-if="orderInfo.length > 1") 共选中{{orderInfo.length}}个订单
            span(v-else) {{orderInfo[0].contentName}}
          h6(v-else-if="orderInfo.contentName") {{orderInfo.contentName}}
          h6(v-else) --

          button(style="outline: none;" @click="chooseNewOrder") 选择订单
          .time(v-if="orderInfo.length || orderInfo.contentName") {{putDateStr}}
            span(@click="seeDtl") 订单详情>>
          .time(v-else) --
        .content
          .tab
            .message
              p.count(v-if="oneStar")
                span(style="color: #B39A70;") VIP
                i.iconfont.icon-bangzhu
                  i.tip {{oneStarTip}}
              p.count(style="color: #B39A70;" v-else) {{ orderReport.realFlowNumStat === undefined ? '--' : orderReport.realFlowNumStat.toLocaleString() }}
              p.text(style="width: 210px;") 总触达流量（人次）
                span.see-dtl(v-if="oneStar")
                  img(src="../../assets/icon_crowd.png")
                  | 流量详情
                  i.tip {{oneStarTip}}
                span(v-else style="margin-left:3px;" @click="seeDataDtl")
                  img(src="../../assets/icon_crowd.png")
                  | 流量详情
          .tab
            .message
              p.count {{ orderReport.realTargetFlowNumStat === undefined ? '--' : orderReport.realTargetFlowNumStat.toLocaleString() }}
              p.text 总目标流量（人次）
          .tab
            .message
              p.count {{ matchRate }}
              p.text 匹配度（%）
          .tab
            .message(style="border-right:none")
              p.count {{ orderReport.realPlayCountStat === undefined ? '--' : orderReport.realPlayCountStat.toLocaleString() }}
              p.text 播放次数（次）
          //- .tab
            .message
              p.count
                span(v-if="orderReport.totalCost !== undefined")
                  span(style="font-size: 16px;") ￥
                  | {{fee((orderReport.totalCost - 0) / 1000)}}
                  span(style="font-size: 16px;") .{{fee((orderReport.totalCost - 0) / 1000, 1)}}
                span(v-else) --
              p.text 广告费用

      .echart-ctn
        .gg-tab(
          v-for="(item, i) in chartTabs"
          :key="i"
          :class="{'cur': curEchartType == i}"
          @click="curEchartType = i") {{item}}

        .echart-main
          .not-see(v-if="noEchartData")
            div 暂无数据，快去投广告吧~
            span(@click="goUrl('/putOrderMap')" style="margin-top: 10px;color: #FF3973;cursor: pointer;") 点击投放广告>>

          template(v-else)
            .switch-ctn(v-if="isCanSee")
              .tab(
                v-for="(item, i) in tabConfig" :key="i" @click="curSwitchIdx = i"
                :class="{'cur': curSwitchIdx === i}"
                v-if="!(hasTimeLimit && item === '分时')"
              ) {{item}}

            .not-see(v-if="!isCanSee")
              div 哎呀，您不能查看此模块！
              span 消费金额到达10000元后即可开启此模块

            .pie-title(v-if="isCanSee") {{echartsTitle}}
              span(v-if="curSwitchIdx == 1")
                span.l 切换日期（
                el-datePicker(
                  v-model="pieDate" size="mini" value-format="yyyy-MM-dd" @change="getOrderGraphInfo"
                  :picker-options="datePickerOptions"
                )
                span.r ）>>

            //- v-if 加上 !isFlowDetail && !showChoosedOrder 是为了
            //- 防止查看人群画像和此页的订单列表时变化窗口返回时图表变的超级小
            EchartOrderData(
              v-if="!isFlowDetail && !showChoosedOrder && !chooseMode"
              :data="echartPieData" :showDataTab="curEchartType" :timeType="curSwitchIdx"
              :curOrderInfo="orderInfo"
            )

            .echart-title(v-if="!oneStar && curEchartType == 0")
              span
                span.color(style="background: #FF3973")
                | 目标流量
              span
                span.color(style="background: #6296FF")
                | 触达流量

        .part-title 数据明细
        el-table(size="mini" :data="tableData" border height="400")
          el-table-column(label="日期" prop="date" min-width="80px" align="center")
            template(slot-scope="{row}") {{row.date.replace(/-/g, '.')}}
          template(v-if="hasTimeLimit")
            el-table-column(label="覆盖小区" prop="validNbhdNum" min-width="80px" align="center")
              template(slot-scope="{row:{baseData}}") {{spNum(baseData ? baseData.validNbhdNum : null)}}
            el-table-column(label="覆盖屏幕" prop="validDeviceNum" min-width="80px" align="center")
              template(slot-scope="{row:{baseData}}") {{spNum(baseData ? baseData.validDeviceNum : null)}}
          template(v-else)
            el-table-column(label="覆盖小区" prop="planNbhdNum" min-width="80px" align="center")
              template(slot-scope="{row:{baseData}}") {{spNum(baseData ? baseData.validNbhdNum : null)}}/{{spNum(baseData ? baseData.planNbhdNum : null)}}
            el-table-column(label="覆盖屏幕" prop="planDeviceNum" min-width="80px" align="center")
              template(slot-scope="{row:{baseData}}") {{spNum(baseData ? baseData.validDeviceNum : null)}}/{{spNum(baseData ? baseData.planDeviceNum : null)}}
          //- el-table-column(label="计划流量" prop="planFlowNum" min-width="80px" align="center")
            template(slot-scope="{row:{baseData}}") {{spNum(baseData ? baseData.planFlowNum : null)}}
          el-table-column(label="播放次数" prop="realPlayCount" min-width="80px" align="center")
            template(slot-scope="{row:{baseData}}") {{spNum(baseData ? baseData.realPlayCount : null)}}
          el-table-column(min-width="80px" align="center")
            template(slot="header")
              span 触达流量
              el-tooltip(:content="oneStarTip" placement="top" v-if="oneStar")
                i.iconfont.icon-bangzhu(style="top: 2px;")
            template(slot-scope="{row:{baseData}}")
              span(v-if="oneStar") VIP专属数据
              span(v-else) {{spNum(baseData ? baseData.realFlowNum : null)}}
          el-table-column(min-width="80px" align="center")
            template(slot="header")
              span 目标流量
              el-tooltip(:content="oneStarTip" placement="top" v-if="oneStar")
                i.iconfont.icon-bangzhu(style="top: 2px;")
            template(slot-scope="{row:{baseData}}")
              span(v-if="oneStar") VIP专属数据
              span(v-else) {{spNum(baseData ? baseData.targetFlowNum : null)}}

        Pagination.page_box(
          style="padding: 8px;border: 1px solid #e9e9e9;border-top: none;border-bottom: none;position: relative;width: 100%;left: 0;"
          :total="pageInfo.total" :current-page.sync="pageInfo.current" :size.sync="pageInfo.size"
          @fn-change="getList"
        )
</template>

<script>
import EchartOrderData from "@/components/EchartOrderData.vue"
import ChooseOrderMake from "./orderReportMake"
import ChoosedOrder from "@/components/ChoosedOrder"
import CrowdData from "./CrowdData"
import Pagination from "@/components/Pagination"
import {
  getOrderGraphDay,
  getOrderGraphSegment
} from "@/utils/api"

export default {
  name: "OrderReport",
  components: {
    ChooseOrderMake,
    CrowdData,
    Pagination,
    EchartOrderData,
    ChoosedOrder
  },
  data() {
    let vm = this;
    return {
      oneStarTip: "消费金额到达1万后即可查看此数据",
      tabConfig: ['分天'], // 2023-10-18 v4.28.0 在线图表隐藏'分时'入口
      showChoosedOrder: false,
      pieTitles: ["广告流量分布", "广告费用分布", "有效匹配分布"],
      codes: [], // 已选的 orderCodes
      orders: [],
      // chartTabs: ['广告流量', '广告费用', '匹配率'],
      chartTabs: ['广告流量', '匹配率'],
      echartPieData: [],
      pieDate: "",
      tableDataAll: [],
      tableData: [],
      pageInfo: { current: 1, total: 0, size: 10 },
      isFlowDetail: false,
      crowdData: null,
      curEchartType: 0,
      curSwitchIdx: 0,
      echartsTitle: "广告流量分布",
      chooseMode: false,
      orderInfo: [],
      orderReport: {},
      datePickerOptions: {
        disabledDate(data) {
          if (!vm.orderInfo.startDate && !vm.orderInfo.length) return true;
          if (Array.isArray(vm.orderInfo)) {
            let times = vm.orderInfo
              .reduce((data, cur) => {
                if (cur.startDate) data.push(cur.startDate);
                if (cur.endDate) data.push(cur.endDate);
                return data;
              }, [])
              .sort();
            return (
              new Date(data).setHours(0, 0, 0) -
              new Date(times[0]).setHours(0, 0, 0) <
              0 ||
              new Date(data).setHours(0, 0, 0) -
              new Date(times[times.length - 1]).setHours(0, 0, 0) >
              0
            );
          } else {
            return (
              new Date(data).setHours(0, 0, 0) -
              new Date(vm.orderInfo.startDate).setHours(0, 0, 0) <
              0 ||
              new Date(data).setHours(0, 0, 0) -
              new Date(vm.orderInfo.endDate).setHours(0, 0, 0) >
              0
            );
          }
        }
      },
      noEchartData: true
    };
  },
  computed: {
    hasTimeLimit() {
      return this.orderInfo.filter(el => el.targetType == 3).length;
    },
    matchRate() {
      const { realFlowNumStat, realTargetFlowNumStat } = this.orderReport
      return realFlowNumStat ? (realTargetFlowNumStat / realFlowNumStat * 100).toFixed(2) : '--'
    },
    // fee() {
    //   return (money, type) => {
    //     if (!money) return type ? "00" : 0;
    //     let isMinus = money < 0;
    //     if (isMinus) money = 0 - money;
    //     if (!type) {
    //       let arr = (Math.floor(money) + "").split("").reverse();
    //       let a = [];
    //       arr.forEach((el, i) => {
    //         a.push(el);
    //         if ((i + 1) % 3 == 0) a.push(",");
    //       });
    //       let str = a.reverse().join("");
    //       let data = str.charAt(0) == "," ? str.slice(1) : str;
    //       return isMinus ? "-" + data : data;
    //     } else {
    //       let sp = (money + "").split(".");
    //       return sp.length > 1
    //         ? sp[1].length == 1
    //           ? sp[1] + "0"
    //           : sp[1].substr(0, 2)
    //         : "00";
    //     }
    //   };
    // },
    customer() {
      return this.$store.state.customer.customerInfo;
    },
    isAuth() {
      // 客户资料是否认证通过
      if (this.customer && this.customer.advertiserType)
        return this.customer.checkStatus === 1; // 审核通过(生效)
      return false;
    },
    oneStar() {
      return (
        !this.orderReport ||
        !this.orderReport.hasOwnProperty("realTargetFlowNumStat") ||
        this.orderReport.realTargetFlowNumStat === -1
      );
    },
    isCanSee() {
      // 是否可以查看图表
      return this.isAuth && (!this.oneStar || this.curEchartType == 1);
    },
    // 已选订单投放日期中的最早开始时间和最晚结束时间
    startEndDate() {
      if (Object.prototype.toString.call(this.orderInfo) == "[object Array]") {
        let sortStart = this.orderInfo.map(el => el.startDate).sort()
        let sortEnd = this.orderInfo.map(el => el.endDate).sort()
        if (!sortStart.length || !sortEnd.length) return []
        return [sortStart[0], sortEnd[sortEnd.length - 1]]
      } else {
        const { startDate: st, endDate: et } = this.orderInfo
        return [st, et]
      }
    },
    putDateStr() {
      if (this.startEndDate.length > 1) {
        const [start, end] = this.startEndDate
        if (start === end) return start
        // 开始与结束时间为同一年份,结束时间展示为MM-DD
        if (start.slice(0, 4) === end.slice(0, 4)) return `${start}~${end.slice(5)}`
        return `${start}~${end}`
      }
      return ''
    }
  },
  watch: {
    curSwitchIdx(v) {
      if (v == 0) this.pieDate = "";
      else {
        if (
          Object.prototype.toString.call(this.orderInfo) == "[object Array]"
        ) {
          // 默认最早订单的第一天
          let sort = this.orderInfo.map(el => el.startDate).sort();
          this.pieDate = sort[0];
        } else this.pieDate = this.orderInfo.startDate;
      }
      this.getOrderGraphInfo();
    },
    curEchartType(v) {
      this.echartsTitle = this.pieTitles[v];
    }
  },
  created() {
    // 默认展示数据展示从这里获取，不从列表的第一个有效订单获取
    this.initInfoOrder();
  },
  methods: {
    async initInfoOrder() {
      const res = await this.fetch('/dsp/web/order/v2/getOrderContentUseCanSelect', {}, 'get')
      if (res && res.code == this.successCode && res.data) {
        this.changeOrder(res.data)
      }
    },
    seeDataDtl() {
      this.isFlowDetail = true
      tzx_czcPush("order_report", "seeDataDetail")
    },
    seeDtl() {
      tzx_czcPush("order_report", "seeChooseDetail")
      if (this.orderInfo.guid || this.orderInfo.length === 1) {
        let guid = this.orderInfo.guid || this.orderInfo[0].guid
        window.open("/mapOrderDetail?noBack=1&id=" + guid)
        return
      }
      this.showChoosedOrder = true;
    },
    async getList() {
      let p = this.pageInfo.current;
      let s = (p - 1) * this.pageInfo.size;
      this.tableData = this.tableDataAll.slice(s, s + this.pageInfo.size);
    },
    chooseNewOrder() {
      this.chooseMode = true;
      tzx_czcPush("order_report", "isChooseOrder");
    },
    async getOrderGraphInfo() {
      if (!this.orderInfo) return;
      this.orders = Array.isArray(this.orderInfo)
        ? this.orderInfo
        : [this.orderInfo];
      this.codes = Array.isArray(this.orderInfo)
        ? this.orderInfo.map(el => el.orderCode).join(",")
        : this.orderInfo.orderCode || "";
      if (!this.codes) return;
      const dayParam = {
        orderCodes: this.codes,
        startDate: this.startEndDate[0],
        endDate: this.startEndDate[1]
      }
      const segParam = {
        orderCodes: this.codes,
        startDate: this.pieDate,
        endDate: this.pieDate
      }
      const response = this.curSwitchIdx == 0 ? await getOrderGraphDay(dayParam) : await getOrderGraphSegment(segParam)
      this.echartPieData = []; // 重置 清除图标数据

      if (!response || response.code != 0) return

      if (response.data) {
        let result = response.data;
        let list = [];
        if (this.curSwitchIdx === 0) { // 分天
          list = result.aggDateStats || [];
          this.orderReport = result;
          this.pageInfo.total = 0;
          this.tableDataAll = list.map(el => {
            // 处理改变列表数据
            let data = JSON.parse(JSON.stringify(el));
            if (this.oneStar) {
              data.realFlowNum = "--";
              data.targetFlowNum = "--";
            }
            return data;
          });
          this.tableDataAll.reverse()
          this.pageInfo.current = 1
          this.pageInfo.total = list.length
          this.tableData = this.tableDataAll.slice(0, this.pageInfo.size)
        } else if (this.curSwitchIdx === 1) {
          list = result;
        }
        this.echartPieData = list;
      }
    },
    changeOrder(data) {
      this.orderInfo = Array.isArray(data) ? data : [data]
      this.noEchartData = false
      if (this.curSwitchIdx != 0) {
        this.curSwitchIdx = 0 // 选好订单回来 默认切换回分天的数据
      } else {
        this.getOrderGraphInfo()
      }
    }
  }
};
</script>

<style lang="sass">
.pie-title
    .el-date-editor
        width: 165px
        cursor: pointer
        z-index: 1
        input
            border: none
            padding: 0
            color: #6296FF
            background: none
            padding-left: 70px
            padding-right: 32px
            cursor: pointer
        .el-input__prefix, .el-input__suffix
            display: none

// .order-report
//     .el-table
//         overflow: visible
//         th, .el-table__header-wrapper
//             overflow: visible
//             >.cell
//                 overflow: visible
</style>

<style lang="sass" scoped>
.icon-bangzhu
    font-size: 18px
    color: #999
    margin-left: 5px
    font-weight: normal
    position: relative
    z-index: 1
    &:hover
        i
            display: block

.see-dtl
    position: relative
    &:hover
        i
            display: block
i.tip
    display: none
    position: absolute
    top: -40px
    left: 20px
    width: 200px
    height: 40px
    line-height: 40px
    color: #fff
    background: rgba(40,39,41,.8)
    font-size: 12px
    font-style: normal
    text-align: center
    border-radius: 4px
    &.right
        left: auto
        right: 20px

.echart-title
    text-align: center
    position: relative
    top: -20px
    font-size: 12px
    >span
        display: inline-block
        width: 100px
        margin: 0 auto
    .color
        display: inline-block
        width: 20px
        height: 2px
        margin-right: 10px
        position: relative
        top: -3px

.p-main
    position: relative
    height: calc(100% - 80px)
    overflow: auto
    background: none
    border-radius: 10px 10px 0 0
    > div
        position: relative
        height: 100%
        overflow: auto
.order_message
    width: 100%
    // height: 240px
    position: absolute
    top: 0
    left: 0
    padding: 20px 20px 0
    background: #FFF
    border-bottom: 1px solid #e9e9e9
    // box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.09)
    // border-radius: 10px 10px 0 0
    .top
        padding: 0 20px
        h6
            display: inline-block
            font-size: 18px
            margin-bottom: 10px
            height: 24px
        button
            float: right
            width: 100px
            height: 30px
            background: linear-gradient(315deg, rgba(250, 234, 97, 1) 0%, rgba(255, 184, 31, 1) 100%)
            border: none
            font-weight: 600
            border-radius: 4px
            cursor: pointer
        .time
            font-size: 12px
            height: 16px
            span
                display: inline-block
                padding-left: 20px
                border-left: 1px solid #e9e9e9
                margin-left: 20px
                cursor: pointer
                color: #FF3973
    .table
        margin-top: 10px
        .title
            height: 40px
            padding: 10px 0
            background: #F1F1F1
            text-align: center
            span
                display: inline-block
                width: 100%
                font-weight: 600
                border-right: 1px solid #D4D4D4
        .table_info
            text-align: center
            line-height: 20px
            padding: 10px
            border-right: 1px solid rgba(#282729, .12)
            border-bottom: 1px solid rgba(#282729, .12)
            overflow: hidden
            white-space: nowrap
            text-overflow: ellipsis
            -o-text-overflow: ellipsis
.content
    // padding: 0 20px
    overflow: hidden
    border-top: 1px solid #e9e9e9
    margin: 20px -20px 0
    min-width: 920px
    .tab
        float: left
        width: 25%
        // background: #F5F5F5
        // width: calc(20% - 8px)
        text-align: left
        padding: 36px 0 36px 40px
        border-right: 1px solid #D4D4D4
        .message
            font-size: 16px
            p.count
                font-size: 28px
                font-weight: 800
                font-family: 'Akrobat-ExtraBold'
            .text
                font-size: 14px
                color: #999
                span
                    color: #6296FF
                    margin-left: 30px
                    cursor: pointer
                    display: inline-block
                    img
                        width: 12px
                        margin-right: 4px
                        float: left
                        position: relative
                        top: 3px
.echart-ctn
    background: #FFF
    padding: 20px 20px 0
    // height: 100%
    overflow: auto
    .echart-main
        position: relative
        border: 1px solid #E9E9E9
        padding: 40px 40px 30px
        height: 416px
        margin-bottom: 20px
        .not-see
            position: absolute
            z-index: 1
            left: 0
            top: 0
            width: 100%
            height: 100%
            background: #f5f5f5
            font-size: 16px
            text-align: center
            padding-top: 180px
            line-height: 1.5
            span
                color: #999
                font-size: 14px
        .switch-ctn
            position: absolute
            right: 20px
            top: 20px
            width: 84px
            height: 30px
            text-align: center
            background: #F5F5F5
            border-radius: 30px
            padding: 4px 0
            .tab
                height: 22px
                line-height: 22px
                width: 50%
                color: #999
                font-size: 12px
                border-radius: 30px
                display: inline-block
                cursor: pointer
                &.cur
                    background: #FF3973
                    color: #fff
    .pie-title
        font-size: 18px
        font-weight: 600
        > span
            color: #6296FF
            position: relative
            margin-left: 20px
            display: inline-block
            line-height: 28px
            cursor: pointer
            font-weight: normal
            font-size: 14px
            span
                position: absolute
                z-index: 0
                top: 0
                display: inline-block
                &.l
                    left: 0
                    width: 70px
                &.r
                    right: 0
                    width: 32px
</style>
